export type AddressCacheKey = "shipping" | "billing";

export interface AddressCache {
  firstName?: string;
  lastName?: string;
  mobile?: string;
  addressLine1?: string;
  addressLine2?: string;
  suburb?: string;
  postcode?: string;
  state?: string;
  country?: string;
}

const cache: Record<AddressCacheKey, AddressCache> = {
  shipping: {},
  billing: {},
};

export const setLastKnownAddress = (
  key: AddressCacheKey,
  value: AddressCache
) => {
  cache[key] = {
    ...cache[key],
    ...Object.fromEntries(
      Object.entries(value).filter(([, val]) => !!val && `${val}`.length > 0)
    ),
  };
};

export const getLastKnownAddress = (key: AddressCacheKey): AddressCache =>
  cache[key];
